module.exports = __webpack_public_path__ + "static/media/UC-San-Diego-logo.61c10ad8.png";